import React from 'react';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { RequestersIcon, TokensIcon } from 'components/Icon';
import { SimpleInlineHelp } from 'components/InlineHelp';

export const TabBar: React.FC = observer(() =>
{
  const { uiStore } = useStore();

  return (
    <div className="tabbar">
      <ul>
        <li>
          <RequestersIcon />
          <NavLink to={paths.buildRequesterListPath()} activeClassName="active">{uiStore.labels.pages.audience.tabs.requesters}</NavLink>
          <SimpleInlineHelp>{uiStore.labels.help.audience.requesters.about}</SimpleInlineHelp>
        </li>
        <li>
          <TokensIcon />
          <NavLink to={paths.buildRequesterTokenListPath()} activeClassName="active">{uiStore.labels.pages.audience.tabs.tokens}</NavLink>
          <SimpleInlineHelp>{uiStore.labels.help.audience.requester_tokens.about}</SimpleInlineHelp>
        </li>
      </ul>
    </div>
  );
});